import { type CaseReducer, type PayloadAction } from '@reduxjs/toolkit';

import { type DocumentsFilters, type FilterGroupState } from '../types';

const updateDocumentsFiltersCase: CaseReducer<
  FilterGroupState,
  PayloadAction<Partial<DocumentsFilters>>
> = (state, action) => {
  state.documents = {
    ...state.documents,
    ...action.payload,
  };

  return state;
};

export { updateDocumentsFiltersCase };
